module.exports = __webpack_public_path__ + "static/media/Sample-Listening-Matching-trimmed.ff68f5ac.mp3";